import { ACCUTRADE_NON_PROD, ACCUTRADE_PROD, ATPostMessageOutbound } from "src/components/AccuTrade/accuTradeHelpers";
import useSelector from "src/utils/useSelector";
import { getAccuTradeBaseUrl } from "src/store/selectors/account";
import { useEffect } from "react";

export const useAccuTradeListener = (
    window: Window,
    listener: (
        data: ATPostMessageOutbound,
        source: MessageEventSource,
        self: (e: MessageEvent<ATPostMessageOutbound | string | null>) => void
    ) => void
) => {
    const accuTradeBaseUrl = useSelector(getAccuTradeBaseUrl);

    useEffect(() => {
        const callback = (e: MessageEvent<ATPostMessageOutbound | string | null>) => {
            if (
                ![ACCUTRADE_PROD, ACCUTRADE_NON_PROD].some((baseUrl) => baseUrl.includes(e.origin)) ||
                !e.data ||
                !e.source
            ) {
                return;
            }


            const data = typeof e.data === "string" ? (JSON.parse(e.data) as ATPostMessageOutbound) : e.data;

            listener(data, e.source, callback);
        };

        window.addEventListener("message", callback);
        return () => window.removeEventListener("message", callback);
    }, [accuTradeBaseUrl]);
};
